<template>
    <div class="message" :class="{ 'is-read': data.read, 'is-opened': activeNews === data.id }">
        <div
            :id="`message-${data.id}`"
            class="richTable-row message__header border-0 p-0"
            data-toggle="collapse"
            :data-target="`#message-${idx}`"
            aria-expanded="false"
            :aria-controls="`message-${idx}`"
            @click="showNews"
        >
            <div class="richTable-col message__status" style="--width-md: 5%">
                <a-icon style="width: 24px; height: 24px" icon="Circle" />
            </div>
            <div class="richTable-col" style="--width-md: 95%; padding-right: 0;">
                <h2 class="message__title">{{ data.title }}</h2>
                <div class="mb-0 message__lead" v-html="data.body"></div>
                <button
                    v-if="activeNews === data.id"
                    class="btn btn-outline btn-sm mr-auto"
                    style="color:inherit"
                    @click.stop="onNotificationRemove"
                >
                    <a-icon icon="Close" />
                    Usuń
                </button>
            </div>
            <div class="richTable-col message__actions">
                <span>{{ data.publicationDate.slice(0, 11) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showMore: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: true
        }
    },
    computed: {
        activeNews() {
            return this.$store.getters.getActiveNews
        }
    },
    methods: {
        onNotificationRemove() {
            this.$store
                .dispatch('removeSingleNews', this.data.id)
                .then(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Powiadomienie zostało usunięte.'
                    })
                })
                .catch(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
        },
        showNews() {
            const newsId = this.activeNews === this.data.id ? 0 : this.data.id
            this.$store.dispatch('setActiveNews', newsId).then(() => {
                this.$store.dispatch('markOneNewsAsRead', newsId)
            })
        }
    }
}
</script>
